<template>
  <div class="leftNav">
    <div class="navItem" :class="{ active: activeIndex === 0 }" @click="jump('home-hot-sale')">
      热卖产品
    </div>
    <div class="navItem" :class="{ active: activeIndex === index + 1 }" v-for="(item, index) in dynamicsList"
      :key="index" @click="jump('a' + index)">
      {{ item.titleName }}
    </div>
  </div>
</template>
<script>
import { spliceString, elementIsVisibleInViewport, scrollIntoView } from "@/utils";

export default {
  data() {
    return {
      leftIndex: "",
      activeIndex: 0, // 滚动时在视图中的模块序号
      dynamicsList: [],
      timer: null,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.getVisible);
  },
  destroyed() {
    window.removeEventListener("scroll", this.getVisible);
  },
  methods: {
    jump(domId) {
      console.log("jump", domId);
      const dom = document.getElementById(domId);
      scrollIntoView(dom)
    },
    setDynamicsList(list) {
      this.dynamicsList = list;
      this.$nextTick(() => {
        // 设置第一个视图
        this.setFirstVisible();
      })
    },
    setFirstVisible() {
      // 通过 categ 链接参数控制默认展示楼层
      const { categ } = this.$route.query
      const index = this.dynamicsList.findIndex((item) => {
        return item.titleName === categ
      })
      this.jump('a' + index)
    },
    // 获取哪些模块在视图里
    getVisible() {
      const visibleIndex = this.visibleIndex();
      if (visibleIndex.length >= 1) {
        this.$nextTick(() => {
          this.activeIndex = visibleIndex[0];
        });
      } else {
        this.activeIndex = 0;
      }
    },
    // 返回视图内的相应序号
    visibleIndex() {
      const homeHotSaleDom = document.getElementById("home-hot-sale");
      let jumpArr = [];
      let allSides = [homeHotSaleDom];

      const homeDynamicsDom = document.getElementById("home-dynamics");
      // console.dir(homeDynamicsDom);

      if (homeDynamicsDom) {
        [...homeDynamicsDom.children].forEach((item) => {
          const targetDom = item;
          if (targetDom) {
            allSides.push(targetDom);
          }
        });
      }
      allSides.forEach((item, index) => {
        elementIsVisibleInViewport(item, true, 0, 240) && jumpArr.push(index);
      });
      return jumpArr;
    },
  },
};
</script>

<style lang="scss" scoped>
.leftNav {
  width: 92px;
  border-radius: 16px;
  padding: 2px;
  background: #f5f6fa;
  position: fixed;
  left: 10px;
  top: 40vh;
  z-index: 100;

  .navItem {
    width: 88px;
    height: 36px;
    border-radius: 14px;
    font-family: Alibaba PuHuiTi;
    font-size: 14px;
    font-weight: 400;
    line-height: 36px;
    text-align: center;
    color: #666;
    cursor: pointer;
  }

  .active {
    background: #fff;
    color: #2a54d1;
    font-weight: 700;
  }
}
</style>
